import {useInjex} from '@injex/react-plugin';
import ChartsManager from '../managers/ChartsManager.mdl';

export default function useChartsManager(): ChartsManager {
    const [inject] = useInjex();
    return inject<ChartsManager>('chartsManager');
}
